import { defineComponent as _defineComponent } from 'vue'
import iconArrowLiteVue from '@/icons/icon-arrow-lite-right.vue';
  import AppButton from './AppButton.vue';
  import iconRocket from '@/icons/icon-rocket.vue';
  import lottie from '../assets/lottie/business-chart.json';
  import centerLottie from '../assets/lottie/business-goal.json';
  import IconCharts from '@/icons/icon-charts.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeFeaturesGrid',
  setup(__props, { expose: __expose }) {
  __expose();

  
const __returned__ = { iconArrowLiteVue, AppButton, iconRocket, get lottie() { return lottie }, get centerLottie() { return centerLottie }, IconCharts }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})